import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { RefuseExternalProviderPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const refuseExternalProviderPayment = createApiThunk<void, RefuseExternalProviderPaymentBody>(
  "externalProviderPayments/refuseExternalProviderPayment",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.refuseExternalProviderPayment(body);
  },
);

export const resetRefuseExternalProviderPayment = createAction("externalProviderPayments/resetRefuseExternalProviderPayment");
